// extracted by mini-css-extract-plugin
export default {"mobileCompletePage":"axnui-mobile-complete-page__mobile-complete-page__z4D_6"};